// extracted by mini-css-extract-plugin
module.exports = {"badgeCount":"NotificationBadgeCount_badgeCount__YVrhW"};